module.exports = __webpack_public_path__ + "img/marker.0a3a106e.svg";